<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <form class="form-div">
    <p class="heading">What is your current education/employment status?</p>
    <div class="employment-container">
      <div class="form-row">
        <div class="input-div">
          <p class="input-label">What year are you in?</p>
          <mat-form-field appearance="fill" class="rounded-input black-caret"
            [class.valid-input]="schoolYearControl.valid && schoolYearControl.value"
            [class.invalid-input]="schoolYearControl.invalid && schoolYearControl.touched">
            <mat-select [formControl]="schoolYearControl" panelClass="rounded-select-panel separated-select-options">
              @for (year of schoolYearOptions; track $index) {
                <mat-option [value]="year.value">{{ year.label }}</mat-option>
              }
            </mat-select>
            @if (schoolYearControl.hasError('required') && (
              schoolYearControl.touched || schoolYearControl.dirty)
            ) {
              <mat-error>
                Please select year
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="input-div">
          <p class="input-label">What is your expected college graduation year?</p>
          <mat-form-field appearance="fill" class="rounded-input black-caret"
            [class.valid-input]="graduationControl.valid && graduationControl.value"
            [class.invalid-input]="graduationControl.invalid && graduationControl.touched">
            <mat-select [formControl]="graduationControl" panelClass="rounded-select-panel separated-select-options">
              @for (year of schoolGraduationOptions; track $index) {
                <mat-option [value]="year.value">{{ year.label }}</mat-option>
              }
            </mat-select>
            @if (graduationControl.hasError('required') && (
              graduationControl.touched || graduationControl.dirty)
            ) {
              <mat-error>
                Graduation year is required
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        @if (!isAUTenant) {
        <div class="input-div">
          <p class="input-label">What is the name of your school?</p>
          <mat-form-field appearance="fill" class="rounded-input black-caret"
            [class.valid-input]="schoolNameControl.valid && schoolNameControl.value"
            [class.invalid-input]="schoolNameControl.invalid && schoolNameControl.touched">
            <mat-select [formControl]="schoolNameControl" required panelClass="rounded-select-panel separated-select-options">
              @for (name of schoolNameOptions; track $index) {
                <mat-option [value]="name.value">{{ name.label }}</mat-option>
              }
            </mat-select>
            @if (schoolNameControl.hasError('required') && (
              schoolNameControl.touched || schoolNameControl.dirty)
            ) {
              <mat-error>
                School name is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        }

        <div class="input-div">
          <p class="input-label">What is your intended/declared Major? (Optional)</p>
          <mat-form-field appearance="fill" class="rounded-input black-caret"
            [class.valid-input]="majorControl.valid && majorControl.value"
            [class.invalid-input]="majorControl.invalid && majorControl.touched">
            <input
              type="text"
              matInput
              [formControl]="majorControl"
              [matAutocomplete]="auto"
              class="major-text"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayMajorLabel" class="separated-dropdown-options">
              @for (major of filteredMajorOptions | async; track $index) {
                <mat-option [value]="major">
                  {{ major.label }}
                </mat-option>
              }
            </mat-autocomplete>

            @if (majorControl.hasError('invalidMajor') && majorControl.touched) {
              <mat-error class="input-error">
                Invalid major
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="horizontal-line"></div>

      <div class="work-div">
        <mat-checkbox [formControl]="isWorking">
          Working while in school
        </mat-checkbox>

        <!-- Show job only when user selects above checkbox -->
        @if (isWorking.value) {
          <div class="divider">|</div>

          <mat-radio-group [formControl]="jobControl" class="job-radio-group">
            @for (option of jobOptions; track $index) {
              <mat-radio-button class="job-option" [value]="option.value">
                {{ option.label }}
              </mat-radio-button>
            }
          </mat-radio-group>
        }
      </div>
    </div>

    <app-biq-button (buttonEmitter)="onClickContinue()"></app-biq-button>
  </form>
</div>